import { retryOn429 } from './sharetribeSafeQuery';

/**
 * Run `work` once more after a short wait when Sharetribe returns 429.
 *
 * @param {Function} work
 * @param {number} [waitMs]
 * @returns {Promise<*>}
 */
export const retryOnceOn429 = (work, waitMs) => retryOn429(work, { retries: 1, waitMs });
